import {
    get, getFamily,
    NetworkState, NetworkStateFamily,
    networkStateReducer, networkStateReducerFamily, post, reset, resetFamily, resolveFamily,
} from "../networkStateReducer";

import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../index";
import { BanksResult, Customer } from ".";


export const domain = "@appigo-retailer/affiliate/get-customer"

export const getCustomerReducer = networkStateReducerFamily<Customer>(domain)

export function useGetCustomer (family: string = 'Default') : [NetworkState<Customer>, () => void,() => void] {
    let dispatch = useDispatch();

    return [
        resolveFamily(family, useSelector<RootState, NetworkStateFamily<Customer>>(state => state.affiliate.getCustomer)),
        () => dispatch(getFamily(domain, "/customer-api/v2/affiliate/customer", family)),
        () => dispatch(resetFamily(domain, family))
    ]
}